<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link
                class="btn btn-sm back-btn"
                :to="{ name: 'ProvisionList' }"
              ><i class="icon-left"></i>
              </router-link>
              <span>View Device Activation</span>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Provision</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Provision">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt=""/>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 form-group">
                <label class="control-label">Name</label>
                <div class="position-relative name">
                   <div class="form-control align-items-center"
                       v-html="value.initial_configuration.username">
                   </div>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="control-label">Email</label>
                <div class="position-relative activation-email">
                   <div class="form-control align-items-center"
                       v-html="value.initial_configuration.activation_email">
                   </div>
                </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="control-label">MAC ID</label>
                   <div class="form-control align-items-center"
                       v-html="value.mac">
                   </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="control-label">Product</label>

                    <div class="form-control align-items-center"
                       v-html="value.twoghz_ssid">
                    </div>

              </div>
              <div class="col-md-4 form-group">
                <label class="control-label">Device</label>
                 <div class="form-control align-items-center"
                       v-html="value.device_type">
                 </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="control-label">Device Name</label>
                 <div class="form-control align-items-center"
                       v-html="value.initial_configuration.device_name">
                 </div>
              </div>
              <div class="col-md-4 form-group">
                <label class="control-label">Activation Date</label>
                 <div class="form-control align-items-center"
                       v-html="value.account.activation_date">
                 </div>
              </div>
              <div class="col-md-4 mb-3 mb-md-0">
                <label class="control-label">licence</label>
                 <div class="form-control align-items-center"
                       v-html="value.sgrp">
                 </div>
              </div>
              <div class="col-md-4 mb-3 mb-md-0">
                <label class="control-label">Activation Status</label>
                <div
                  v-if="value.activation_status == 'Due Activation'"
                  class="form-control align-items-center"
                >
                  <span class="select-status bg-secondary"></span>
                  Due Activation
                </div>
                <div
                  v-else-if="value.activation_status == 'Activated'"
                  class="form-control align-items-center"
                >
                  <span class="select-status bg-success"></span>
                  Activated
                </div>
                <div
                  v-else-if="value.activation_status == 'De-Activated'"
                  class="form-control align-items-center"
                >
                  <span class="select-status bg-danger"></span>
                  De-Activated
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mt-3">
          <div class="card-body">
            <h4 class="card-common-title p-0 mb-3 pb-3 border-bottom">
              Advanced Settings
            </h4>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="control-label">WAN Auto Config</label>
                 <div class="form-control align-items-center"
                  v-html="pre.configOptions[value.initial_configuration.wan_configure_automatically]">
                </div>
              </div>
            </div>

            <div
              class="row"
              v-if="value.initial_configuration.wan_configure_automatically == 1"
            >
              <div class="col-md-12">
                <div class="row">
                  <div class="col form-group">
                    <label class="control-label">ISP</label>
                     <div class="form-control align-items-center"
                        v-html="pre.ispOptions[value.initial_configuration.wan_isp_type]">
                     </div>
                  </div>

                  <div class="col form-group">
                    <label class="control-label">Network</label>
                     <div class="form-control align-items-center"
                        v-html="pre.networkOptions[value.initial_configuration.wan_network_type]">
                     </div>
                  </div>
                  <div
                    class="col"
                    v-if="value.initial_configuration.wan_network_type == 'dhcp'"
                  >
                    <div class="form-group">
                      <label class="control-label">Configure Automatically</label>
                       <div class="form-control align-items-center"
                        v-html="pre.configAutomaticallyOptions[value.initial_configuration.wan_dhcp_configure_automatically]">
                     </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="row"
                  v-if="value.initial_configuration.wan_dhcp_configure_automatically == 0"
                >
                  <div class="col-md-4 form-group">
                    <label class="control-label">Preferred DNS</label>
                    <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_dhcp_preferred_dns">
                        </div>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="control-label">Alternative DNS</label>
                    <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_dhcp_alternat_dns">
                      </div>
                  </div>

                  <div
                    v-if="value.initial_configuration.wan_isp_type == 'other'"
                    class="col-md-4 form-group"
                  >
                    <label class="control-label">VLAN ID</label>
                    <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_pppoe_vlan_id">
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="row"
                  v-if="value.initial_configuration.wan_network_type == 'pppoe'"
                >
                  <div class="col-md-4 form-group">
                    <label class="control-label">User Name</label>
                   <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_pppoe_username">
                      </div>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="control-label">Password</label>
                      <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_pppoe_password">
                      </div>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="control-label">Configure Automatically</label>
                    <div class="form-control align-items-center"
                        v-html="pre.configAutomaticallyOptions[value.initial_configuration.wan_pppoe_configure_automatically]">
                     </div>
                  </div>

                  <div class="col-md-12">
                    <div
                      class="row"
                      v-if="value.initial_configuration.wan_pppoe_configure_automatically == 0"
                    >
                      <div class="col-md-4 form-group">
                        <label class="control-label">Access Concentrator</label>
                          <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_pppoe_access_concentrator">
                      </div>
                      </div>
                      <div class="col-md-4 form-group">
                        <label class="control-label">Service Name</label>
                         <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_pppoe_service_name">
                      </div>
                      </div>

                      <div class="col-md-4 form-group">
                        <label class="control-label">Preferred DNS</label>
                          <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_pppoe_preferred_dns">
                      </div>
                      </div>

                      <div class="col-md-4 form-group">
                        <label class="control-label">Alternative DNS</label>
                         <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_pppoe_alternat_dns">
                      </div>
                      </div>

                      <div
                        v-if="value.initial_configuration.wan_isp_type == 'other'"
                        class="col-md-4 form-group"
                      >
                        <label class="control-label">VLAN ID</label>
                         <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_pppoe_vlan_id">
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div
                  class="row"
                  v-if="value.initial_configuration.wan_network_type == 'static'"
                >
                  <div class="col-md-4 form-group">
                    <label class="control-label">IP Address</label>
                    <div class="form-control align-items-center"
                             v-html="value.initial_configuration.wan_static_ip_address">
                    </div>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="control-label">Subnet Mask</label>
                    <div class="form-control align-items-center"
                      v-html="value.initial_configuration.wan_static_subnet_mask">
                    </div>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="control-label">Default Gateway</label>
                    <div class="form-control align-items-center"
                      v-html="value.initial_configuration.wan_static_default_gateway">
                    </div>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="control-label">Preferred DNS</label>
                    <div class="form-control align-items-center"
                      v-html="value.initial_configuration.wan_static_preferred_dns">
                    </div>
                  </div>

                  <div class="col-md-4 form-group">
                    <label class="control-label">Alternative DNS</label>
                   <div class="form-control align-items-center"
                      v-html="value.initial_configuration.wan_static_alternat_dns">
                    </div>
                  </div>

                  <div
                    v-if="value.initial_configuration.wan_isp_type == 'other'"
                    class="col-md-4 form-group"
                  >
                    <label class="control-label">VLAN ID</label>
                    <div class="form-control align-items-center"
                      v-html="value.initial_configuration.wan_pppoe_vlan_id">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <h4 class="card-common-title p-0 mb-3 pb-3 border-bottom">
            </h4>

            <div class="col-md-6 mb-3">
              <label class="control-label">LAN Auto Config</label>
              <div class="form-control align-items-center"
                   v-html="pre.configOptions[value.initial_configuration.lan_configure_automatically]">
              </div>
            </div>
            <div
              class="row"
              v-if="value.initial_configuration.lan_configure_automatically == 1"
            >
              <div class="col-md-3 form-group">
                <label class="control-label">IP Address</label>
                <div class="form-control align-items-center"
                     v-html="value.initial_configuration.lan_ip">
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label class="control-label">Subnet Mask</label>
                <div class="form-control align-items-center"
                     v-html="value.initial_configuration.lan_subnet_mask">
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label class="control-label">Start IP</label>
                <div class="form-control align-items-center"
                     v-html="value.initial_configuration.lan_start_ip">
                </div>
              </div>
              <div class="col-md-3 form-group">
                <label class="control-label">End IP</label>
                <div class="form-control align-items-center"
                     v-html="value.initial_configuration.lan_end_ip">
                </div>
              </div>
            </div>

          </div>
        </div>

        <div v-if="value.application_alias.voip_enable == 1">
          <div class="card mt-3">
            <div class="p-4">
              <div class="panel-body">
                <div class="switch-row justify-content-between">
                  <h4 class="card-common-title p-0">
                    <i class="fas fa-phone-alt mr-2" aria-hidden="true"></i>
                    VoIP
                  </h4>
                  <el-switch
                    v-model="value.voip_configuration.voip_enable"
                    active-color="#009E9D"
                    inactive-color="#E5E5E5"
                    disabled
                  >
                  </el-switch>
                </div>
              </div>
              <el-collapse-transition>
                <div class="VoIP-content" v-show="value.voip_configuration.voip_enable">
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-md-4 form-group">
                        <label class="control-label">Caller ID</label>
                        <div class="form-control align-items-center"
                             v-html="value.voip_configuration.display_name">
                        </div>
                      </div>
                      <div class="col-md-4 form-group">
                        <label class="control-label">VOiP Number</label>
                        <div class="form-control align-items-center"
                             v-html="value.voip_configuration.sip_number">
                        </div>
                      </div>
                      <div class="col-md-4 form-group">
                        <label class="control-label">SIP Server</label>
                        <div class="form-control align-items-center"
                             v-html="value.voip_configuration.sip_server">
                        </div>

                      </div>
                      <div class="col-md-4 form-group">
                        <label class="control-label">SIP Port</label>
                        <div class="form-control align-items-center"
                             v-html="value.voip_configuration.sip_port">
                        </div>
                      </div>
                      <div class="col-md-4 form-group">
                        <label class="control-label">Login ID</label>
                       <div class="form-control align-items-center"
                             v-html="value.voip_configuration.login_id">
                        </div>
                      </div>
                      <div class="col-md-4 form-group">
                        <label class="control-label">Password</label>
                        <div class="password">
                         <div class="form-control align-items-center"
                             v-html="value.voip_configuration.password">
                        </div>
                        </div>
                      </div>
                      <div class="col-md-12 form-group">
                        <div class=" card-common-title p-0 pt-3 d-flex align-items-center justify-content-between">
                          <label class="fw-500 m-0">Proxy Enable</label>
                          <el-switch
                            v-model="value.voip_configuration.proxy_enable"
                            active-color="#009E9D"
                            inactive-color="#E5E5E5"
                            disabled
                          >
                          </el-switch>
                        </div>
                      </div>
                      <el-collapse-transition>
                        <div class="col-md-12" v-if="value.voip_configuration.proxy_enable">
                          <div class="row">
                            <div class="col-md-6 form-group">
                              <label class="control-label">Proxy Server</label>
                               <div class="form-control align-items-center"
                                 v-html="value.voip_configuration.proxy_server">
                               </div>
                                <!-- <el-select
                                  v-model="value.voip_configuration.proxy_server_type"
                                  slot="prepend"
                                  style="width: 110px"
                                  disabled
                                >
                                  <el-option label="Select" value=""></el-option>
                                  <el-option label="IP" value="ip"></el-option>
                                  <el-option label="Domain" value="domain"></el-option>
                                </el-select> -->

                            </div>
                            <div class="col-md-6 form-group">
                              <label class="control-label">Proxy Port</label>
                              <div class="form-control align-items-center"
                                v-html="value.voip_configuration.proxy_port">
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-collapse-transition>

                    </div>
                    <a
                      class="card-common-title p-0 py-3 fw-500 d-flex align-items-center justify-content-between"
                      data-toggle="collapse"
                      href="#PacketizationSettings"
                      role="button"
                      aria-expanded="false"
                      aria-controls="collapseExample"
                    >
                      Codec & Packetization Settings <i class="icon-down"></i>
                    </a>
                    <div class="collapse packetization" id="PacketizationSettings">
                      <div class="table-responsive">
                        <table class="table">
                          <thead>
                          <tr>
                            <th>Type</th>
                            <th>Packetization</th>
                            <th>1</th>
                            <th>2</th>
                            <th>3</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(codec, index) in value.voip_configuration.codec_setting" :key="index">
                            <td>{{ codec.type }}</td>
                            <td>
                              <el-select
                                v-model="codec.packetization"
                                placeholder="Select"
                                disabled
                              >
                                <el-option label="10 ms" :value="10"></el-option>
                                <el-option label="20 ms" :value="20"></el-option>
                                <el-option label="30 ms" :value="30"></el-option>
                                <el-option label="40 ms" :value="40"></el-option>
                              </el-select>
                            </td>
                            <td v-for="i in 3" :key="i">
                              <label class="radio">
                                <input
                                  type="radio"
                                  :name="'priority-' + i"
                                  :value="i"
                                  :checked="codec.priority == i"
                                  disabled
                                />
                                <span class="radio-mark"></span>
                              </label>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>

            </div>
          </div>

        </div>

      </div>
    </section>
  </div>
</template>

<script>
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import ElCollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {

  name: "ProvisionView",
  metaInfo: {
    title: "Provision | Dotlines",
  },

  components: {
    DatePicker, ElCollapseTransition
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    is_loading: false,
    params: {},
    codecs: [
      {type: "G711-ulaw", packetization: 20, priority: 1},
      {type: "G711-alaw", packetization: 20, priority: 2},
      {type: "G729", packetization: 20, priority: 3},
    ],
    value: {
      account: {
        device_name: "",
        activation_email: "",
        activation_date: "",
      },
      initial_configuration: {
        lan_ip: "192.168.20.1",
        lan_subnet_mask: "255.255.255.0",
        wan_static_subnet_mask: "255.255.255.0",
        lan_start_ip: "192.168.20.100",
        lan_end_ip: "192.168.20.250",
        wan_dhcp_preferred_dns: "",
        wan_pppoe_preferred_dns: "",
        wan_static_preferred_dns: "",
        wan_dhcp_alternat_dns: "",
        wan_pppoe_alternat_dns: "",
        wan_static_alternat_dns: "",
        wan_isp_type: "other",
        wan_dhcp_configure_automatically: 1,
        wan_pppoe_configure_automatically: 1,
        wan_network_type: "dhcp",
        lan_configure_automatically: 0,
        wan_configure_automatically: 0,
        display_name: "",
        sip_number: "",
        sip_server: "",
        sip_server_type: "",
        sip_port: "",
        login_id: "",
        password: "",
        proxy_server: "",
        proxy_server_type: "",
        proxy_port: "",
      },
      voip_configuration: {
        voip_enable: false,
        proxy_enable: false,
        codec_setting: []
      },
      application_alias: {}
    },
    pre: {
      configOptions: {
        1: "NO",
        0: "YES",
      },
      configAutomaticallyOptions: {
        1: "YES",
        0: "NO",
      },
      ispOptions: {
        unify: "UniFi - Malaysia",
        maxis: "Maxis - Malaysia",
        other: "Regular ISP Profile",
      },
      networkOptions: {
        dhcp: "DHCP",
        pppoe: "PPPoE",
        static: "Static IP Address",
      },
      subnetMasks: [],
      routerList: {},
      timeZoneList: {},
    },
  }),
  methods: {
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/provisions/" + id;
        axios
          .get(api_url, {
            params: {accountId: LocalStorage.get("accountId")},
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSubnetMasks: function () {
      return new Promise((resolve, reject) => {
        const api_url = "/get-provision-subnet-masks";
        axios
          .get(api_url, {
            params: {accountId: LocalStorage.get("accountId")},
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getTimeZone: function () {
      return new Promise((resolve, reject) => {
        const api_url = "/get-time-zone";
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        await this.getDetail(this.params.id)
          .then((response) => {
            let res_data = response.data;
            if (!res_data.hasOwnProperty('voip_configuration')) {
              res_data.voip_configuration = {}
            }
            if (!res_data.hasOwnProperty('application_alias')) {
              res_data.application_alias = {voip_enable: 0}
            }
            if (res_data.application_alias.voip_enable == 1) {
              if (!res_data.voip_configuration.hasOwnProperty('codec_setting') || res_data.voip_configuration.codec_setting == null || res_data.voip_configuration.codec_setting.length == 0) {
                res_data.voip_configuration.codec_setting = this.codecs
              }
            } else {
              res_data.voip_configuration = {}
            }
            if (!(res_data.hasOwnProperty('initial_configuration') && res_data.initial_configuration.hasOwnProperty('lan_configure_automatically'))) {
              res_data.initial_configuration.lan_configure_automatically = 0
            }
            if (!(res_data.hasOwnProperty('initial_configuration') && res_data.initial_configuration.hasOwnProperty('wan_configure_automatically'))) {
              res_data.initial_configuration.wan_configure_automatically = 0
            }
            this.value = res_data;
          })
          .catch((errors) => {
            if (errors.hasOwnProperty('response')) {
              if (errors.response.status === 501) {
                this.$toaster.error(errors.response.data.errors.message);
              } else if (errors.response.data) {
                this.$toaster.error(errors.response.data.message);
              }
            }
          });
      }

      await this.getSubnetMasks()
        .then((response) => {
          this.pre.subnetMasks = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getTimeZone()
        .then((response) => {
          this.pre.timeZoneList = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
<style scoped>
a[aria-expanded="true"] i::before {
  content: "\e917";
}

a[aria-expanded="true"]:hover {
  color: #111;
}

.theme-audra .table > tbody > tr > td:first-child {
  color: #657182;
}

.table > tbody > tr > td:first-child {
  font-weight: normal;
}

.theme-audra .table > thead > tr > th[data-v-532122d6] {
  background-color: #F9F9F9;
  border: none !important;
  color: #1E1E1E;
}

.theme-audra .table > thead > tr > th:first-child {
  border-radius: 8px 0 0 8px;
}

.theme-audra .table > thead > tr > th:last-child {
  border-radius: 0 8px 8px 0;
}

.table td, .table th {
  padding: 1rem;
  vertical-align: middle;
  border: none !important;
}

.table > tbody > tr > td:last-child, .table > thead > tr > th:last-child {
  text-align: start;
}

.table > tbody > tr:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, .7);
}

/* Style for readonly/disabled fields */
.form-control[readonly],
.form-control:disabled,
.multiselect--disabled {
  background-color: #f8f9fa !important;
  opacity: 0.8;
  cursor: not-allowed;
}

.el-switch.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
